import React from "react"
import { Link } from "react-router-dom"

export default function Nav({ user }) {
  const handleLogout = () => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/auth/logout", {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken
      }
    }).then(() => window.location.reload())
  }

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-gray-900">
              Farmer Brown
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-medium">
              {user.name?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <span className="text-sm text-gray-700">{user.name}</span>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}
